import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { LoadingService } from '../../services/loading.service';
import { SharedService } from '../../services/shared.service';

import { SignService } from '../sign.service';
import { NotificationsService } from '../../services/notifications.service';

@Component({
  selector: 'asv-forgot-password',
  template: `
    <div class="content-box form-width section-top login">
      <form class="mx-auto" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <h2 class="text-center">{{ 'sign.forgot_password.title' | translate }}</h2>
        <h3 class="text-center">{{ 'sign.forgot_password.description' | translate }}</h3>
        <div class="form-group mt-5">
          <label for="field_email">{{ 'forms.fields.email' | translate }}</label>
          <input type="email"
                 class="form-control"
                 id="field_email"
                 formControlName="email"
                 placeholder="{{ 'forms.fields.email' | translate }}">
        </div>
        <div class="form-group mt-5">
          <button type="submit"
                  class="btn btn-success btn-block">{{ 'buttons.remind_password' | translate }}</button>
          <button type="button" class="btn btn-info btn-block" (click)="confirmCode()">{{ 'buttons.have_code' | translate }}</button>
          <button type="button" class="btn btn-secondary btn-block" (click)="cancel()">{{ 'buttons.cancel' | translate }}</button>
        </div>
      </form>
    </div>
  `,
  styles: [`
    :host {
      width: 100%;
    }
  `]
})
export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordForm: FormGroup;
  public showErrors: boolean;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private signService: SignService,
    private notificationsService: NotificationsService,
    private sharedService: SharedService
  ) {
    this.showErrors = false;
  }

  ngOnInit() {
    this.makeForm();
    this.showErrors = false;
  }

  public onSubmit() {
    if (this.forgotPasswordForm.valid) {
      this.loadingService.show();
      this.showErrors = false;
      return this.signService.forgotPassword(this.forgotPasswordForm.value).subscribe((response) => {
        const body = response;
        if (body.status === 201) {
          this.notificationsService.success('Code sent!');
          this.loadingService.hide();
          this.sharedService.setUserEmail(this.forgotPasswordForm.value);
          this.router.navigateByUrl('/code-confirm');
        } else {
          this.notificationsService.error(body.error_fields.email);
        }
        this.loadingService.hide();
      }, (error) => {
        this.loadingService.hide();
        this.notificationsService.error(error);
      });
    } else {
      this.showErrors = true;
    }
  }

  public makeForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

  }

  public confirmCode() {
    if (this.forgotPasswordForm.valid) {
      this.sharedService.setUserEmail(this.forgotPasswordForm.value);
      this.router.navigateByUrl('/code-confirm');
    }
  }

  public cancel() {
    this.router.navigateByUrl('/sign/signin');
  }

}
